/**
 * Shown on a disabled Cancel action when the viewer holds the cancel permission
 * for the receiving store but not the sending one, and the sending store is a
 * warehouse — i.e. the transfer came out of Centralized Purchasing. Cancelling
 * is sending-side only — see `views/transfer-orders/hooks/useCanCancelTransferOrder`
 * for transfer orders and `views/reports/effects/can-cancel-transaction` for
 * TX-#'d transfers.
 *
 * Lives here rather than in either view because both surfaces show it. Copy is
 * specified verbatim by sc-567498.
 */
export const CANCEL_RESTRICTED_TO_SENDER_TOOLTIP = 'Transfers from Centralized Purchasing can only be cancelled by ' +
	'the Distribution Center team. Please reach out in the #help-central-ordering Slack channel if this transfer needs ' +
	'to be cancelled or there are questions about this shipment.'

/**
 * The same restriction for a transfer whose sending store is an ordinary branch.
 * Transfer orders are sending-side only regardless of the sender, but the copy
 * above names Centralized Purchasing and its Slack channel, which would point a
 * branch-to-branch receiver at the wrong team.
 */
export const CANCEL_RESTRICTED_TO_SENDING_BRANCH_TOOLTIP = 'Only the sending branch can cancel this transfer. ' +
	'Please reach out to them if it needs to be cancelled.'

/** Picks the copy for a receiving-side viewer blocked from cancelling. */
export function cancelRestrictedTooltip( fromIsWarehouse: boolean ): string {
	return fromIsWarehouse ? CANCEL_RESTRICTED_TO_SENDER_TOOLTIP : CANCEL_RESTRICTED_TO_SENDING_BRANCH_TOOLTIP
}
